<template>
  <div
    class="dialog-profile-item-template"
    :class="{ 'hidden-details': !hasDetails }"
  >
    <div class="image">
      <slot name="image" />
    </div>
    <div class="label">
      <slot name="label" />
    </div>
    <div class="details">
      <slot name="details" />
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  disabled?: boolean;
  hasDetails?: boolean;
}

defineProps({
  disabled: { type: Boolean },
  hasDetails: { type: Boolean }
});
</script>
<style lang="scss" scoped>
.dialog-profile-item-template {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap_s);
  height: 100%;
  .image {
    display: flex;
    width: 100%;
    height: auto;
    border-radius: 100%;
    background-color: var(--color_neutral_80);
  }
  .label {
    width: stretch;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: ltr;
  }

  .details {
    @include font('n', 600, 'secondary');

    width: stretch;
    padding: var(--gap_xxs) var(--gap_n);
    overflow: hidden;
    border-radius: var(--stroke_radius_m);
    background-color: var(--color_secondary_lighter);
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: ltr;
  }

  &.hidden-details {
    .details {
      display: none;
    }
    &.disabled {
      .label {
        color: var(--color_neutral_300);
      }
    }
  }
}
</style>
